
import { Component, Vue } from "vue-property-decorator";
import DocumentFields from "@/components/DocumentFields.vue";
import DocumentJoin from "@/components/DocumentJoin.vue";

import "@/assets/css/pages/home.css";
import News from "@/news";
import { Category } from "@/types/woothee_category";
import { Article } from "@/news_articles";

@Component({
  components: { DocumentFields, DocumentJoin },
})
export default class extends Vue {
  linkMenu1ImgUrl = require("@/assets/images/common/link/link_menu1.jpg");
  linkMenu2ImgUrl = require("@/assets/images/common/link/link_menu2.jpg");
  linkMenu3ImgUrl = require("@/assets/images/common/link/link_menu3.jpg");
  articles: Article[] = [];
  kvNum: number = 0;
  intervalId: number = 0;

  mounted() {
    this.mountNews();

    const body = document.getElementsByTagName("body").item(0);
    if (body) {
      if (body.classList.contains("ready")) {
        this.startCarousel();
      } else {
        body.addEventListener("ready", this.startCarousel);
      }
    }
  }

  async mountNews() {
    const l = await News.getListFromRss();
    this.articles = l.slice(0, 5);
  }

  destroyed() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  incrementKvNum() {
    this.kvNum = (this.kvNum + 1) % 2;
  }

  startCarousel() {
    this.intervalId = window.setInterval(this.incrementKvNum, 3500);
  }

  get kv1ImgUrl(): string {
    if ((this as any).$ua.category === Category.Smartphone) {
      return require("@/assets/images/home/kv1_sp.jpg");
    } else {
      return require("@/assets/images/home/kv1_pc.jpg");
    }
  }

  get kv2ImgUrl(): string {
    if ((this as any).$ua.category === Category.Smartphone) {
      return require("@/assets/images/home/kv2_sp.jpg");
    } else {
      return require("@/assets/images/home/kv2_pc.jpg");
    }
  }

  get kv3ImgUrl(): string {
    if ((this as any).$ua.category === Category.Smartphone) {
      return require("@/assets/images/home/kv3_sp.jpg");
    } else {
      return require("@/assets/images/home/kv3_pc.jpg");
    }
  }
}
